import { useEffect, useState } from 'react';

import { MasterInfo } from '../../type/MasterInfoType';
import { DialogType } from '../../type/DialogType';
import { coexistenceGetType } from '../../const/commonConst';
import { getMasterInfoHandler } from '../../handler/getMasterInfoHandler';

const initMasterInfo = {
	offsegOrganizationInfoList: [],
	offsegCarInfoList: [],
	offsegDriverInfoList: [],
	g500LiteOrganizationInfoList: [],
	g500LiteCarInfoList: [],
	g500LiteDriverInfoList: [],
};

/**
 * マスタデータの状態管理用カスタムフック
 */
export const useEffectMasterInfo = (
	getType: (typeof coexistenceGetType)[keyof typeof coexistenceGetType],
	setDialog: (value: React.SetStateAction<DialogType>) => void,
) => {
	const [masterInfo, setMasterInfo] = useState<MasterInfo>(initMasterInfo); // 取得したマスタデータの管理
	// 初回アクセス時、リロード時にマスタデータを取得する
	useEffect(() => {
		const getSearchCriterion = async () => {
			const [dialog, masterInfo] = await getMasterInfoHandler(getType);

			if (!masterInfo) {
				setDialog(dialog);
				return;
			}

			setMasterInfo(masterInfo);
		};

		getSearchCriterion();
	}, []);

	return {
		masterInfo,
		setMasterInfo,
	};
};
